import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=2fde427a&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fde427a')) {
      api.createRecord('2fde427a', component.options)
    } else {
      api.reload('2fde427a', component.options)
    }
    module.hot.accept("./TagList.vue?vue&type=template&id=2fde427a&", function () {
      api.rerender('2fde427a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/tags/TagList.vue"
export default component.exports